import React from 'react';
import { TimePicker } from '@mui/x-date-pickers';
import { Text, VStack, useTheme } from '@chakra-ui/react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const MomentTimePicker = ({
  label, value, onChange, minValue,
}) => {
  const muiTheme = createTheme();
  const theme = useTheme();
  return (
    <VStack align="start" pr={4}>
      <Text
        style={{ ...theme.styles.global.body }}
      >
        {label}

      </Text>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={muiTheme}>
          <TimePicker
            value={value}
            minTime={minValue}
            onChange={onChange}
            slotProps={{
              popper: {
                sx: { zIndex: 1500 },
              },
            }}
            sx={{
              '& input': {
                height: '12px',
                width: '150px',
              },
            }}
          />
        </ThemeProvider>
      </LocalizationProvider>
    </VStack>
  );
};

export default MomentTimePicker;
